export default function DropDown(
    {
        options = [],
        onChange,
        multiple = false,
        selectedValues = [],
        ...rest
    }
) {

    if(!Array.isArray(options)) {
        options = [];
    }

    if (!Array.isArray(selectedValues)) {
        selectedValues = [selectedValues];
    }



    return (
        <select
            onChange={onChange}
            multiple={multiple}
            value={multiple ? selectedValues : selectedValues.pop()}
            {...rest}
        >
            {options?.map((option) => (
                <option
                    key={option.value}
                    value={option.value}
                >
                    {option.label}
                </option>
            ))}
        </select>
    );

}